import { getReportMatchesByPage } from '@/api';
import {
  AppInsightsContext,
  MetadataContext,
  ModuleBase,
  ReportsGrid,
  SystemFeaturesContext,
  TrackEventKey,
  TrackEventName,
  TrackEventType,
  UserContext,
} from '@/components';
import {
  ModuleBaseModel,
  ModuleBasePropsModel,
  ReportSearchModel,
  UiConfigurationModel,
  ReportCardType,
  CognitiveFilterRequestModel,
} from '@/types';
import { useRouter } from 'next/router';
import { useContext } from 'react';

type PersonalisedReportsModuleModel = ModuleBaseModel<
  {
    heading: string;
    headingTag: string;
    description: string;
    anchor: string;
    uiConfiguration?: UiConfigurationModel;
    cards: ReportSearchModel[];
    status: {
      hasDoneSetup: boolean;
      isSubscribed: boolean;
      wantsEmail: boolean;
      weeklyAlert: boolean;
    };
  } & ModuleBasePropsModel
>;

const PersonalisedReportsModule = (data: PersonalisedReportsModuleModel) => {
  const { props } = data;
  const { userSubscriptions } = useContext(SystemFeaturesContext);
  const appInsights = useContext(AppInsightsContext);
  const user = useContext(UserContext);
  const { pageId } = useContext(MetadataContext);
  const router = useRouter();

  if (!props.status.hasDoneSetup || !userSubscriptions) {
    return null;
  }

  const searchFunction = async (filterRequest: CognitiveFilterRequestModel) => {
    const results = await getReportMatchesByPage({
      userId: user?.userId || '',
      pageNum: filterRequest.page || 1,
      pageSize: filterRequest.pageSize || 10,
    });

    return Promise.resolve({ results });
  };

  const onCardClick = (e: React.MouseEvent, data: ReportSearchModel) => {
    appInsights.trackCustomEvent(
      TrackEventName.REPORT,
      TrackEventKey.PERSONALISED_REPORT,
      TrackEventType.SELECTED,
      user,
      {
        pageId,
        pagePath: router.asPath,
        reportID: data.reportId,
      },
    );
  };

  return (
    <ModuleBase data={{ ...data, props: { ...props, noPaddingOnTop: true } }} className="overflow-hidden">
      <div className="mx-auto">
        <ReportsGrid
          uiConfiguration={props.uiConfiguration}
          cards={props.cards}
          cardType={ReportCardType.REPORT}
          heading={{
            heading: props.heading,
            headingTag: 'h2',
          }}
          searchFunction={searchFunction}
          onCardClick={onCardClick}
        />
      </div>
    </ModuleBase>
  );
};

export default PersonalisedReportsModule;
